<template>
    <div id="app">
        <img alt="logo" class="bg" src="./assets/bg.png">
        <div style="position: relative;width: 100%;padding-top: 70rem">
            <h2>会议简介</h2>
            <div class="white">
                <p>
                    河南省"7+28+N"战略跨境电商数字人才赋能计划响应国家"一带一路"倡议与"数字中国"战略，落实河南省7+28+N"现代产业体系布局(7大先进制造业集群、28条重点产业链、N个特色产业生态)。</p>
                <p>
                    聚焦跨境电商产业数字化升级需求，破解"数字外贸人才缺口大产教融合不足、国际竞争力薄弱"三大痛点。
                </p>
                <p>
                    依托河南自贸区、郑州航空港经济综合实验区、中欧班列(郑州)等开放平台，打造"买全球、卖全球"数字贸易枢纽。
                </p>
            </div>
            <Item v-for="item in pageData" :item="item"></Item>
            <div style="padding:2rem 4rem">
                <div style="width: 100%;background: white;height: 2px"></div>
            </div>
            <h2>请填写报名信息</h2>
            <div style="padding: 5rem;width: 100%">
                <FormItem label="姓名">
                    <el-input v-model="form.name">
                        <i class="el-icon-user" style="line-height: 36px;font-size: 3rem" slot="prefix"></i>
                    </el-input>
                </FormItem>
                <FormItem label="单位">
                    <el-input v-model="form.company">
                        <i class="el-icon-office-building" style="line-height: 36px;font-size: 3rem" slot="prefix"></i>
                    </el-input>
                </FormItem>
                <FormItem label="职务">
                    <el-input v-model="form.position">
                        <i class="el-icon-s-custom" style="line-height: 36px;font-size: 3rem" slot="prefix"></i>
                    </el-input>
                </FormItem>
                <FormItem label="手机">
                    <div style="width: 100%">
                        <el-input v-model="form.mobile">
                            <i class="el-icon-mobile" style="line-height: 36px;font-size: 3rem" slot="prefix"></i>
                        </el-input>
                        <el-button @click="getCode" :disabled="!form.mobile || !regex.test(this.form.mobile)"
                                   style="width: 100%;margin-top:10px">
                            {{ getCodeText }}
                        </el-button>
                    </div>
                </FormItem>
                <FormItem label="验证码" v-if="show">
                    <el-input v-model="form.code" v-if="">
                        <i class="el-icon-chat-dot-square" style="line-height: 36px;font-size: 3rem" slot="prefix"></i>
                    </el-input>
                </FormItem>
                <el-button style="width: 100%;margin-top:10px" @click="submit">
                    报名参加
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

import FormItem from "@/components/form-item";
import axios from "axios";
import {pageData} from "@/assets/data";
import Item from "@/components/item";
export default {
	name: 'App',
	components: {FormItem,Item},
	data() {
		return {
			form: {
				name: '',
				mobile: '',
				company: '',
				position: '',
				code: '',
			},
			pageData,
			getCodeText: '点击获取验证码',
			timer: null,
			show: null,
			regex: /^1[3-9]\d{9}$/
		}
	},
	methods: {
		getCode() {
			if (this.getCodeText !== '点击获取验证码') {
				return
			}
			if (!this.form.mobile || !this.regex.test(this.form.mobile)) {
				return
			}
			axios.get('https://topic.728.org.cn/api/index/code?mobile=' + this.form.mobile).then(res => {
				this.show = true
				const {code, msg} = res.data || {}
				if (code) {
					this.$message.success(msg)
				} else {
					this.$message.error(msg)
				}
				this.getCodeText = '60s后重新获取'
				let time = 60
				clearInterval(this.timer)
				this.timer = setInterval(() => {
					time--
					this.getCodeText = `${time}s后重新获取`
					if (time === 0) {
						clearInterval(this.timer)
						this.getCodeText = '点击获取验证码'
					}
				}, 1000)
			})

		},
		submit() {
			axios.post('https://topic.728.org.cn/api/index/regist', this.form).then(res => {
				const {code, msg} = res.data || {}
				if (code) {
					this.$message.success(msg)
					this.form = {}
				} else {
					this.$message.error(msg)
				}
			})
		}
	}
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
</style>
